import React, { useState, useEffect } from 'react';
import dayjs from "../../../../util/dayjs-config";
import { Modal, Button, Form } from 'react-bootstrap';
import { FluentDatePicker } from '../../../../components/FluentUI/Fluent-DatePicker';
import { 
    GetTemplateTaskCount,
    TransferProjectOwnerShip,
    UpdateProjectTasksEndDate,
} from '../../../../services/api/project-api';
import PropTypes from 'prop-types';
import { calendarIcon } from "../../../../assets/icons";
import "./project-ownership-transfer.scss";

const TransferModal = ({ 
    projectId,
    dateFormatID,
    originalOwner,
    selectedOwner,
    setSelectedOwner,
    originalProjectEndDate,
    selectedProjectEndDate,
    projectTasksCount,
    isTransferModalOpen,
    setIsTransferModalOpen,
    projectTransferType,
    setProjectTransferType,
    setShowEditedModal,
    setErrorModal,
    labels
}) => {
    const [taskCount, setTaskCount] = useState(0);
    const [extendTaskEndDate, setExtendTaskEndDate] = useState(false);
    const [selectedTaskEndDate, setSelectedTaskEndDate] = useState(null);
    const [invalidTaskEndDate, setInvalidTaskEndDate] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setSelectedTaskEndDate(originalProjectEndDate);
        setExtendTaskEndDate(false);
    }, []);

    useEffect(() => {
        setSelectedTaskEndDate(selectedProjectEndDate);
    }, [selectedProjectEndDate]);

    useEffect(() => {
        const projectEndDate= selectedProjectEndDate || originalProjectEndDate;
        if ((selectedTaskEndDate > projectEndDate) && extendTaskEndDate) {
            setInvalidTaskEndDate(true);
        } else {
            setInvalidTaskEndDate(false);
        }
    }, [selectedTaskEndDate]);

    useEffect(() => {
        const projectEndDate= selectedProjectEndDate || originalProjectEndDate;
        if ((selectedTaskEndDate > projectEndDate) && extendTaskEndDate) {
            setInvalidTaskEndDate(true);
        } else if (!extendTaskEndDate) {
            setInvalidTaskEndDate(false);
        } else {
            setInvalidTaskEndDate(false);
        }
    }, [extendTaskEndDate]);

    useEffect(() => {
        if (isTransferModalOpen) {
            GetTemplateTaskCount(projectId, originalOwner?.id ?? originalOwner?.Id) //Remove after deprecation
                .then((result) => {
                    setTaskCount(result?.data || 0);
                })
                .catch((error) => {
                    console.log("GetTemplateTaskCount", error);
                });
        } else {
            setSelectedOwner(originalOwner);
            setSelectedTaskEndDate(selectedProjectEndDate);
        }
    }, [isTransferModalOpen])

    const onOwnershipCancel = () => {
        setSelectedOwner(originalOwner);
        setSelectedTaskEndDate(selectedProjectEndDate);
        setExtendTaskEndDate(false);
        setIsTransferModalOpen(false)
        setProjectTransferType(1);
    }

    const onOwnershipError = (error) => {
        setSelectedOwner(originalOwner);
        setSelectedTaskEndDate(selectedProjectEndDate);
        setErrorModal(error);
        setIsTransferModalOpen(false);
        setSaving(false);
    }

    const onOwnershipTransfer = async () => {
        try {
            setSaving(true);
            let data = {
                ProjectId: projectId,
                OldProjectOwnerId:  originalOwner?.id ?? originalOwner?.Id,
                NewProjectOwnedId: selectedOwner?.id ?? selectedOwner?.Id,
                ProjectTransferType: projectTransferType,
            }
            let output = await TransferProjectOwnerShip(data);
            if (output?.status === 200) {
                if(output?.data === true) {
                    if (extendTaskEndDate) {
                        await ProjectTasksEndDateSave(projectId, selectedTaskEndDate);
                    }
                    setShowEditedModal(true);
                    setSaving(false);                   
                } else {
                    onOwnershipError("Failed to transfer ownership");
                }
            } else {
                onOwnershipError(output?.response?.data);
            }
        } catch (error) {
            onOwnershipError(error);
        }
    }

    const ProjectTasksEndDateSave = async (projectId, taskEndDate) => {
        try {
            let data = {
                    Id: projectId,
                    TasksEnd: dayjs(taskEndDate).endOf('day').format("YYYY-MM-DDTHH:mm:ss")
                }
            let  output = await UpdateProjectTasksEndDate(data);            
            
            if (output?.status === 200) {
                if (output?.data === true) {
                    return true;
                } else {
                    onOwnershipError(`Failed to update ${labels?.ProjectSingular ?? "Project"} ${labels?.TaskPlural ?? "Tasks"} Due Date`);
                }
            } else {
                onOwnershipError(output?.response?.data);
            }
        } catch (error) {
            onOwnershipError(error);
            return false;
        }
    }
    return (
        <Modal 
            className="project-ownership-modal"
            show={isTransferModalOpen}
            onHide={() => setIsTransferModalOpen(false)}
        >
            <Modal.Header>
                <Modal.Title className='title'>
                    Transfer {labels?.ProjectSingular ?? "Project"} Ownership
                </Modal.Title>
                <Button
                    className="close-document-viewer-btn btn-primary"
                    onClick={() => setIsTransferModalOpen(false)}
                />
            </Modal.Header>
            <Modal.Body className="action-popup">
                <div>
                    <Form.Row>
                        <p className="description">
                            You currently have ownership of {taskCount} templated {labels?.TaskPlural ?? "Tasks"} that were automatically assigned to you. Choose an action for {labels?.TaskSingular ?? "Task"} ownership:
                        </p>
                        <h3 className="action-panel-text options">
                            <label className="workflow-radio">
                                <input
                                    className={"filter-panel-dropdown-members-radio-button mt-1"}
                                    type="radio"
                                    name="project-ownership"
                                    value={0}
                                    checked={projectTransferType === 0}
                                    onChange={() => { setProjectTransferType(0) }}
                                />
                                <div>
                                    <span className='item'>
                                        Retain {labels?.TaskSingular ?? "Task"} Ownership:
                                    </span>
                                    <span className="item-description"> Transfer only the {labels?.ProjectSingular ?? "Project"} Ownership to the new {labels?.ProjectSingular ?? "Project"} Owner while keeping ownership of the {labels?.TaskPlural ?? "Tasks"}.</span>
                                </div>
                            </label>
                            <label className="workflow-radio">
                                <input
                                    className={"filter-panel-dropdown-members-radio-button mt-1"}
                                    type="radio"
                                    name="project-ownership"
                                    value={1}
                                    checked={projectTransferType === 1}
                                    onChange={() => { setProjectTransferType(1) }}
                                />
                                <div>
                                    <span className='item'>
                                        Transfer {labels?.TaskSingular ?? "Task"} Ownership:
                                    </span>
                                    <span className="item-description"> Transfer both {labels?.ProjectSingular ?? "Project"} Ownership and {labels?.TaskSingular ?? "Task"} Ownership to the new {labels?.ProjectSingular ?? "Project"} Owner.</span>
                                </div>
                            </label>
                        </h3>
                    </Form.Row>
                    {   projectTasksCount > 0 &&
                        <Form.Row>
                            <p className="description">
                                Would you like to extend the end date for all the active {labels?.TaskPlural ?? "tasks"} in this {labels?.ProjectSingular ?? "Project"}?
                            </p>
                            <div className="mt-3 mb-1">
                                <Form.Group>
                                    <FluentDatePicker
                                        id="taskEndDate"
                                        name="taskEndDate"
                                        data-testid="taskEndDate"
                                        autoComplete="off"
                                        placeholder="Click to select a new task due date"
                                        value={selectedTaskEndDate || originalProjectEndDate}
                                        onChange={(value) => setSelectedTaskEndDate(value)}
                                        maxDate={selectedProjectEndDate || originalProjectEndDate}
                                        isInvalid={invalidTaskEndDate}
                                        feedback={invalidTaskEndDate ? `Please select a date on or before the ${labels?.ProjectSingular ?? "project"} end date` : null}
                                        dateFormatID={dateFormatID}
                                        disabled={!extendTaskEndDate}
                                    />
                                    {   !invalidTaskEndDate &&
                                        <img className="calendar-icon" src={calendarIcon} alt="Calendar Icon" />
                                    }
                                </Form.Group>
                                <Form.Group>
                                    <Form.Check
                                        id="enableTaskEndDate"
                                        name="enableTaskEndDate"
                                        data-testid="enableTaskEndDate"
                                        type="checkbox"
                                        checked={extendTaskEndDate}
                                        onChange={(e) => { setExtendTaskEndDate(e.target.checked) }}
                                        className="task-end-date-checkbox"
                                    />
                                    <Form.Label htmlFor="enableTaskEndDate" className="task-end-date-checkbox">
                                        Update {labels?.TaskSingular ?? "Task"} Due Date
                                    </Form.Label>
                                </Form.Group>
                            </div>
                        </Form.Row>
                    }
                    <div className="action-buttons">
                        <Button className="btn-outlined" onClick={onOwnershipCancel}>Cancel</Button>
                        <Button disabled={saving || (invalidTaskEndDate)} onClick={onOwnershipTransfer}>Save</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

TransferModal.propTypes = {
    projectId: PropTypes.number.isRequired,
    dateFormatID: PropTypes.string.isRequired,
    originalOwner: PropTypes.object,
    selectedOwner: PropTypes.object,
    setSelectedOwner: PropTypes.func,
    originalProjectEndDate: PropTypes.string,
    selectedProjectEndDate: PropTypes.string,
    projectTasksCount: PropTypes.number,
    isTransferModalOpen: PropTypes.bool.isRequired,
    setIsTransferModalOpen: PropTypes.func,
    projectTransferType: PropTypes.number.isRequired,
    setProjectTransferType: PropTypes.func,
    setShowEditedModal: PropTypes.func,
    setErrorModal: PropTypes.func,
    labels: PropTypes.object.isRequired
};

export default TransferModal;
